import React from "react";
import { Route, Switch } from "react-router-dom";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import InvestmentEntitiesGrid from "./components/InvestmentEntitiesGrid";

const Entities: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/data-vault/entities">
        <main
          role="main"
          aria-label="Entities content"
          style={{
            padding: SPACING.LARGE,
            height: "100%",
            backgroundColor: Colors.Neutral100,
          }}
        >
          {/* Investment Entities Grid */}
          <section aria-label="Investment entities list" style={{ height: "100%" }}>
            <InvestmentEntitiesGrid />
          </section>
        </main>
      </Route>
    </Switch>
  );
};

export default Entities;
